import React from 'react'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import { ToolbarGroup } from 'material-ui/Toolbar'
import CustomToolbar from './CustomToolbar'
import CustomToolbarTitle from './CustomToolbarTitle'
import CustomToolbarSeparator from './CustomToolbarSeparator'
import CustomFlatButton from 'components/Button/CustomFlatButton'

const StateToolBar = ({
  primary,
  isStateChanged,
  children,
  onDiscard,
  onSave,
  saveStatus,
}) => {
  return (
    <CustomToolbar primary={primary}>
      {
        isStateChanged ?
          <ToolbarGroup>
            <CustomToolbarTitle text="Unpublished changes" primary/>
            <CustomToolbarSeparator primary/>
            <RaisedButton
              label={saveStatus.isRequest ? '...Saving' : 'Save'}
              onTouchTap={() => onSave()}
            />
            <CustomFlatButton
              white
              label="Discard"
              onTouchTap={onDiscard}
            />
          </ToolbarGroup>
          :
          <ToolbarGroup firstChild>
          </ToolbarGroup>
      }
      <ToolbarGroup>
        {children}
      </ToolbarGroup>
    </CustomToolbar>
  )
}

StateToolBar.propTypes = {
  primary: PropTypes.bool.isRequired,
  isStateChanged: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveStatus: PropTypes.object.isRequired,
}

export default StateToolBar



// WEBPACK FOOTER //
// ./src/components/bars/StateToolBar.js